import { SEO } from "@/components/SEO";
import { PageHero } from "@/components/shared";
import { business, fullAddress, routes } from "@/lib/site";

const Block = ({ title, children }) => (
  <div className="mb-8">
    <h2 className="font-heading font-bold text-navy text-xl sm:text-2xl mb-3">{title}</h2>
    <div className="text-ink leading-relaxed space-y-3">{children}</div>
  </div>
);

export default function PrivacyPolicy() {
  return (
    <>
      <SEO
        path={routes.privacy}
        title="Privacy Policy | Dr. Satyam's Pain Healthcare, Varanasi"
        description="Privacy policy for Dr. Satyam's Pain Healthcare, Varanasi — how we handle enquiries and personal information submitted through this website."
      />
      <PageHero title="Privacy Policy" breadcrumb={[{ label: "Privacy Policy" }]} />
      <section className="bg-white py-16 lg:py-20">
        <div className="mx-auto max-w-3xl px-4 sm:px-6 lg:px-8">
          <p className="text-ink leading-relaxed mb-8">
            This Privacy Policy explains how {business.clinicName} ("we", "us") handles information
            you share through this website. By using this website, you agree to the practices described below.
          </p>
          <Block title="Information We Collect">
            <p>When you submit an enquiry or appointment request, you may share your name, phone number,
            email address, preferred date and a short message describing your concern. This information
            is used only to respond to your enquiry and arrange your appointment.</p>
          </Block>
          <Block title="How We Use Your Information">
            <p>We use the details you provide to contact you, schedule appointments and respond to your
            questions. Appointment enquiries submitted through the website may be continued over WhatsApp
            or phone for convenience.</p>
          </Block>
          <Block title="Information Sharing">
            <p>We do not sell or rent your personal information. Your details are used only within the clinic
            to provide care and respond to your enquiry.</p>
          </Block>
          <Block title="Data Security">
            <p>We take reasonable steps to protect the information you share. However, no method of
            transmission over the internet is completely secure.</p>
          </Block>
          <Block title="Contact">
            <p>For any questions about this policy, contact us at {business.phoneDisplay} or visit us at {fullAddress}.</p>
          </Block>
        </div>
      </section>
    </>
  );
}
